import React, { ChangeEvent, Dispatch, FC, SetStateAction } from 'react';
import { Button } from '..';
import { MaxImageSize } from '../../../constants';
import { CloseIcon, UploadIcon } from '../icons';
import Spacing from '../Spacing';
import { CloseIconContainer, ImagePreview, ImagePreviewContainer, Input, InputContainer, Label } from './style';

const INPUT_ACCEPT = {
  image: 'image/*',
  doc: '.pdf',
};

interface InputFileProps {
  file: File | null;
  setFile: Dispatch<SetStateAction<File>>;
  label: string;
  type: 'image' | 'doc';
}

const InputFile: FC<InputFileProps> = ({ file, setFile: setImage, label, type }) => {
  const handleImageUpload = (e: ChangeEvent) => {
    const file = (e.target as HTMLInputElement).files[0];

    if (!file) return;

    if (
      !type ||
      (type === 'image' && !file.type.match(/^image\//)) ||
      (type === 'doc' && !file.type.match(/^application\/pdf/))
    ) {
      return;
    }

    if (file.size >= MaxImageSize.Common) {
      alert(`File size should be less than ${MaxImageSize.Common / 1000000}MB`);
      return;
    }

    setImage(file);
    (e.target as HTMLInputElement).value = null;
  };

  const closeImagePreview = () => {
    setImage(null);
  };

  return (
    <InputContainer>
      {file && type === 'image' && (
        <Spacing bottom="sm">
          <ImagePreviewContainer>
            <CloseIconContainer>
              <Button type="button" ghost shadow={false} onClick={closeImagePreview}>
                <CloseIcon color="white" />
              </Button>
            </CloseIconContainer>
            <ImagePreview src={URL.createObjectURL(file)} />
          </ImagePreviewContainer>
        </Spacing>
      )}
      <Input name="image" onChange={handleImageUpload} type="file" id="upload-image" accept={INPUT_ACCEPT[type]} />
      <Label htmlFor="upload-image">
        <UploadIcon />
        {label && <Spacing left="xs">{label}</Spacing>}
      </Label>
    </InputContainer>
  );
};

export default InputFile;
